export const getIsInStandLegEl = (self, node) => {
  const stand_leg_path_el = self._getStandLegPathElThrowable();
  return stand_leg_path_el.contains(node);
};
